<template>
  <div class="add">
    <delivery-form operate-type="add" @toDeliveryList="transferTabChange"></delivery-form>
  </div>
</template>

<script>
import DeliveryForm from "./component/form";
export default {
  components: {
    DeliveryForm
  },
  methods: {
    transferTabChange() {
      this.$emit('toDeliveryList');
    }
  }
}
</script>